// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Fbi0w","isOpen":"Modal_isOpen__5To2d","header":"Modal_header__F9WtX","content":"Modal_content__9O8Rx","closeButton":"Modal_closeButton__XymbC"};